import { Paths } from "Router/Paths";
export const UserMenuList = [
  {
    id: 1,
    title: "MENU",
    isPublic: true,
    list: [
      {
        title: "PUC Applications",
        path: Paths.userDashboard,
        // module_slug: "home",
        icon: "store",
        view: "View Application",
        update: "Update Status",
        add: "New Application"
        // edit: "Edit Home"
      },
      {
        title: "Payment Requests",
        path: Paths.userPayment,
        // module_slug: "home",
        icon: "payment",
        view: "View ",
        update: "Update Status"
        // add: "New Application"
        // edit: "Edit Home"
      },
      {
        title: "Display Wall",
        path: Paths.displayWallStore,
        icon: "display_wall",
        // view: "View ",
        // update: "Update Status",
        type:"display_wall"
      }
    ]
  }
];
